import { redirect } from "@tanstack/react-router";
import type { ParsedLocation } from "@tanstack/react-router";
import type { RouterContext } from "@/routes/__root.tsx";
import type { Role } from "@/types/api/types.ts";
import { ROLE_SUPER_ADMIN } from "@/constants";

type BeforeLoadArgs = {
  context: RouterContext;
  location: ParsedLocation;
};

export const requireRole = (requiredRoles: Role[]) => {
  return ({ context, location }: BeforeLoadArgs) => {
    const userRole = context.session?.user?.role;

    if (!userRole) {
      throw redirect({
        to: "/unauthorized",
        search: {
          redirect: location.href,
        },
      });
    }

    const isSuperAdmin = userRole === ROLE_SUPER_ADMIN;

    const hasRequiredRole = requiredRoles.includes(userRole);

    if (!isSuperAdmin && !hasRequiredRole) {
      throw redirect({
        to: "/unauthorized",
        search: {
          redirect: location.href,
        },
      });
    }
  };
};
